module.exports = __webpack_public_path__ + "img/Paso4.beee0bc4.svg";